/** One source dataset feeding one Vivo table. */
export interface ProvenanceSource {
  source_system: string;
  source_display_name: string;
  source_dataset: string | null;
  target_table: string;
  rows_loaded: number | null;
  vendor: string | null;
  cadence: string | null;
  access_type: string | null;
  last_synced: string | null;
}

/** One Vivo column and the source field behind it. */
export interface ProvenanceField {
  target_table: string;
  target_column: string;
  source_display_name: string | null;
  source_dataset: string | null;
  source_field: string | null;
  handling: string | null;
  handling_detail: string | null;
}

/** One column and what the schema says it holds. */
export interface ProvenanceColumn {
  target_table: string;
  target_column: string;
  description: string;
}

export interface ProvenancePayload {
  sources: ProvenanceSource[];
  fields: ProvenanceField[];
  columns: ProvenanceColumn[];
}

/** How the load treated a value, as shown on the Fields tab. */
export const HANDLING_LABELS: Record<string, string> = {
  verbatim: "Verbatim",
  transform: "Transform",
  normalized: "Normalized",
  fan_out: "Fan-out",
  derived: "Derived",
  constant: "Constant",
};
